import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";


@Component({
    selector: 'button-dialog',
    templateUrl: './button-dialog.component.html',
    styleUrls: ['./button-dialog.component.scss']
})
export class ButtonDialogComponent implements OnInit {

    type: string;
    remark: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ButtonDialogComponent>,
    ) {
    }


    ngOnInit() {
        this.type = this.data.type
    }

    close(e) {
        let item = {
            type: e,
            remark: this.remark
        }
        this.dialogRef.close(item);
    }

}
